export const siteConfig = {
  appName: 'Halfway House Veterinary Clinic',
  shortName: 'Halfway House',
  packageName: 'halfway-house-veterinary-clinic',
  tagline: 'Calm small-animal care on Pitzer Road, Glen Austin',
  footerDescription:
    'SAVC-registered veterinary care at 154 Pitzer Rd, Glen Austin AH, Midrand. Call for consults, vaccines, surgery, and clear next steps for your pets.',
  phoneDisplay: '010 224 0129',
  phoneHref: 'tel:+27102240129',
  altPhoneDisplay: '011 314 1738',
  altPhoneHref: 'tel:+27113141738',
  emergencyDisplay: '076 511 9838',
  emergencyHref: 'tel:+27765119838',
  email: 'hhvclinic@gmail.com',
  emailHref: 'mailto:hhvclinic@gmail.com',
  addressLine: '154 Pitzer Rd, Glen Austin AH, Midrand, 1685',
  streetAddress: '154 Pitzer Rd',
  locality: 'Midrand',
  region: 'Gauteng',
  postalCode: '1685',
  country: 'ZA',
  areaLabel: 'Glen Austin / Midrand',
  mapsUrl:
    'https://www.google.com/maps/place/Halfway+House+Veterinary+Clinic/@-25.9585857,28.1483529,17z',
  mapsEmbedUrl:
    'https://maps.google.com/maps?q=Halfway+House+Veterinary+Clinic,+154+Pitzer+Rd,+Midrand&t=&z=15&ie=UTF8&iwloc=&output=embed',
  latitude: -25.9585857,
  longitude: 28.1483529,
  reviewsUrl:
    'https://www.google.com/maps/place/Halfway+House+Veterinary+Clinic/@-25.9585857,28.1483529,17z/data=!4m8!3m7!1s0x1e956fb29a3eccab:0x8ad4537d582e0ab!8m2!3d-25.9585857!4d28.1483529!9m1!1b1',
  ratingValue: '4.6',
  reviewCount: '236',
  hoursNote: 'Confirm when you call',
  veterinarianOwner: 'Dr Nathalie Rouget',
  veterinarianTeam: 'Dr Marisa Slabber',
  url: 'https://halfway-house-veterinary-clinic.pages.dev',
  canonicalUrl: 'https://halfway-house-veterinary-clinic.pages.dev/',
} as const;
